import React, { useState } from 'react';
import { Link } from "react-router-dom";
import Icon from '../../../components/AppIcon';

const GlobalVisionSection = () => {
  const [activeRegion, setActiveRegion] = useState('north-america');

  const regions = [
    {
      id: 'north-america',
      name: 'North America',
      icon: 'MapPin',
      status: 'Active',
      students: '3,200+',
      cities: ['San Francisco', 'New York', 'Toronto', 'Austin'],
      color: 'accent'
    },
    {
      id: 'europe',
      name: 'Europe',
      icon: 'MapPin',
      status: 'Expanding',
      students: '1,800+',
      cities: ['London', 'Berlin', 'Amsterdam', 'Stockholm'],
      color: 'success'
    },
    {
      id: 'asia-pacific',
      name: 'Asia Pacific',
      icon: 'MapPin',
      status: 'Launching 2024',
      students: '500+',
      cities: ['Singapore', 'Tokyo', 'Sydney', 'Seoul'],
      color: 'cyber-purple'
    },
    {
      id: 'latin-america',
      name: 'Latin America',
      icon: 'MapPin',
      status: 'Planning',
      students: 'Coming Soon',
      cities: ['São Paulo', 'Mexico City', 'Buenos Aires', 'Bogotá'],
      color: 'warning'
    }
  ];

  const initiatives = [
    {
      icon: 'Globe',
      title: 'Global Accessibility',
      description: 'Making advanced technology education accessible to learners worldwide, regardless of location or economic background.',
      goals: [
        'Multilingual platform support',
        'Regional pricing models',
        'Local partnership networks',
        'Cultural adaptation programs'
      ]
    },
    {
      icon: 'Users',
      title: 'Diverse Communities',
      description: 'Building inclusive learning communities that celebrate diversity and create opportunities for underrepresented groups.',
      goals: [
        'Scholarship programs',
        'Mentorship for minorities',
        'Women in tech initiatives',
        'Accessibility features'
      ]
    },
    {
      icon: 'Zap',
      title: 'Innovation Hubs',
      description: 'Establishing regional innovation centers that foster collaboration between students, industry, and local communities.',
      goals: [
        'Physical learning spaces',
        'Industry partnerships',
        'Startup incubators',
        'Research collaborations'
      ]
    },
    {
      icon: 'BookOpen',
      title: 'Knowledge Sharing',
      description: 'Creating a global knowledge network where learners and educators can share insights, resources, and best practices.',
      goals: [
        'Open-source curriculum',
        'Peer learning networks',
        'Global competitions',
        'Cross-cultural projects'
      ]
    }
  ];

  const milestones = [
    {
      year: '2024',
      title: 'Asia Pacific Launch',
      description: 'Expanding to Singapore, Tokyo, and Sydney with localized programs',
      status: 'in-progress'
    },
    {
      year: '2025',
      title: 'European Growth',
      description: 'Doubling our European presence with new partnerships',
      status: 'planned'
    },
    {
      year: '2026',
      title: 'Latin America Entry',
      description: 'Bringing DCC to major Latin American markets',
      status: 'planned'
    },
    {
      year: '2027',
      title: 'Global Network',
      description: 'Achieving presence in 50+ cities worldwide',
      status: 'vision'
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        {/* <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-accent/10 border border-accent/20 mb-6">
            <Icon name="Globe" size={16} className="text-accent mr-2" />
            <span className="text-sm font-medium text-accent">Global Vision</span>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
            Democratizing Technology Education Worldwide
          </h2>
          
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Our vision extends beyond borders. We're building a global community where anyone, anywhere can access world-class technology education and transform their future.
          </p>
        </div> */}

        {/* Global Presence Map */}
        {/* <div className="mb-20">
          <h3 className="text-2xl font-bold text-foreground text-center mb-12">Our Global Presence</h3>
          
           Region Selector
          {/* <div className="flex flex-wrap justify-center gap-4 mb-12">
            {regions.map((region) => (
              <button
                key={region.id}
                onClick={() => setActiveRegion(region.id)}
                className={`flex items-center space-x-3 px-6 py-3 rounded-xl font-medium transition-all duration-300 ${
                  activeRegion === region.id
                    ? `bg-${region.color} text-white shadow-glow`
                    : 'bg-card/50 text-muted-foreground hover:bg-card/80 hover:text-foreground'
                }`}
              >
                <Icon name={region.icon} size={18} />
                <span>{region.name}</span>
                <span className={`text-xs px-2 py-1 rounded-full ${
                  activeRegion === region.id
                    ? 'bg-white/20'
                    : `bg-${region.color}/20 text-${region.color}`
                }`}>
                  {region.status}
                </span>
              </button>
            ))}
          </div> 

           Active Region Details
          {/* <div className="holographic-card p-8 max-w-4xl mx-auto">
            {(() => {
              const region = regions.find(r => r.id === activeRegion);
              return (
                <div className="grid md:grid-cols-2 gap-8 items-center">
                  <div>
                    <div className="flex items-center space-x-4 mb-6">
                      <div className={`w-16 h-16 bg-gradient-to-br from-${region.color} to-${region.color} rounded-full flex items-center justify-center shadow-glow`}>
                        <Icon name="Globe" size={24} color="white" />
                      </div>
                      <div>
                        <h4 className="text-xl font-bold text-foreground">{region.name}</h4>
                        <p className={`text-${region.color} font-medium`}>{region.status}</p>
                      </div>
                    </div>
                    
                    <div className="space-y-4">
                      <div>
                        <div className="text-sm text-muted-foreground mb-1">Active Students</div>
                        <div className="text-2xl font-bold text-foreground">{region.students}</div>
                      </div>
                      
                      <div>
                        <div className="text-sm text-muted-foreground mb-2">Key Cities</div>
                        <div className="flex flex-wrap gap-2">
                          {region.cities.map((city, index) => (
                            <span key={index} className={`px-3 py-1 bg-${region.color}/10 text-${region.color} text-sm rounded-full border border-${region.color}/20`}>
                              {city}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="text-center">
                    <div className={`w-48 h-48 bg-gradient-to-br from-${region.color}/20 to-${region.color}/10 rounded-full flex items-center justify-center mx-auto border border-${region.color}/20`}>
                      <div className="text-center">
                        <Icon name="MapPin" size={48} className={`text-${region.color} mx-auto mb-4`} />
                        <div className="text-lg font-bold text-foreground">{region.name}</div>
                        <div className="text-sm text-muted-foreground">{region.status}</div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })()}
          </div> 
        </div> */}

        {/* Global Initiatives */}
        {/* <div className="mb-20">
          <h3 className="text-2xl font-bold text-foreground text-center mb-12">Global Initiatives</h3>
          
          <div className="grid md:grid-cols-2 gap-8">
            {initiatives.map((initiative, index) => (
              <div key={index} className="holographic-card p-8 group hover:scale-105 transition-all duration-300">
                <div className="flex items-start space-x-4 mb-6">
                  <div className="w-12 h-12 bg-gradient-to-br from-accent to-cyber-purple rounded-lg flex items-center justify-center flex-shrink-0 shadow-glow group-hover:shadow-glow-strong transition-all duration-300">
                    <Icon name={initiative.icon} size={20} color="white" strokeWidth={2.5} />
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-foreground mb-2">{initiative.title}</h4>
                    <p className="text-muted-foreground mb-4">{initiative.description}</p>
                  </div>
                </div>
                
                <div className="space-y-2">
                  {initiative.goals.map((goal, idx) => (
                    <div key={idx} className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-accent rounded-full"></div>
                      <span className="text-sm text-muted-foreground">{goal}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Expansion Timeline */}
        {/* <div className="bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 md:p-12 border border-border">
          <div className="text-center mb-12">
            <h3 className="text-2xl font-bold text-foreground mb-4">Expansion Roadmap</h3>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Our strategic expansion plan to bring Dream Coders Club to learners worldwide over the next four years.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {milestones.map((milestone, index) => (
              <div key={index} className="relative">
                <div className={`p-6 rounded-xl border transition-all duration-300 ${
                  milestone.status === 'in-progress' ?'bg-accent/10 border-accent/20'
                    : milestone.status === 'planned' ?'bg-success/10 border-success/20' :'bg-cyber-purple/10 border-cyber-purple/20'
                }`}>
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-2xl font-bold text-foreground">{milestone.year}</span>
                    <div className={`w-3 h-3 rounded-full ${
                      milestone.status === 'in-progress' ?'bg-accent animate-pulse'
                        : milestone.status === 'planned' ?'bg-success' :'bg-cyber-purple'
                    }`}></div>
                  </div>
                  
                  <h4 className="font-semibold text-foreground mb-2">{milestone.title}</h4>
                  <p className="text-sm text-muted-foreground">{milestone.description}</p>
                </div>
                
                //Connector Line 
                {index < milestones.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-border"></div>
                )}
              </div>
            ))}
          </div>
        </div> */}

        {/* Call to Action */}
        <div className="text-center">
          <h3 className="text-2xl font-bold text-foreground mb-4">Join Our Community</h3>
          <p className="text-muted-foreground mb-8 max-w-2xl mx-auto">
            Be part of the future of technology education. Whether you're a student, educator, or industry partner, there's a place for you in our global community.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact-support">
              <button className="morphing-cta px-8 py-3 text-white font-semibold rounded-lg flex items-center space-x-2">
                <Icon name="Users" size={20} />
                <span>Connect With Us</span>
              </button>
            </Link>
            {/* <button className="px-8 py-3 bg-card/50 text-foreground font-semibold rounded-lg border border-border hover:bg-card/80 transition-colors duration-300 flex items-center space-x-2">
              <Icon name="Building2" size={20} />
              <span>Partner With Us</span>
            </button> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalVisionSection;